import React from "react";
import { useDrag } from "react-dnd";

import { IFile } from "../../../../state";
import { DnDItemTypes } from "../../../../pages/manager/UploadStudentRealPhotos/types";
import { ReactComponent as CancelIcon } from "../../../../assets/icon/cancel.svg";
import styles from "../UploadStudentRealPhotos.module.scss";

type Props = {
  photo: IFile;
  deleteStudentRealPhotoUploadedFile: (id: number) => void;
};

export default function UploadedPhotoListItem({
  photo,
  deleteStudentRealPhotoUploadedFile,
}: Props) {
  const [{ isDragging }, drag] = useDrag({
    item: { type: DnDItemTypes.PHOTO, value: photo.id },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      className={styles.photo}
      ref={drag}
      style={{ cursor: isDragging ? "grabbing" : "grab" }}
    >
      <CancelIcon
        className={styles.cancelIcon}
        onClick={() => {
          photo.id && deleteStudentRealPhotoUploadedFile(photo.id);
        }}
      />
      <img className={styles.img} src={photo.url} alt={photo.name} />
    </div>
  );
}
